
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ie/cookies",
      function () {
        return require("private-next-pages/ie/cookies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ie/cookies"])
      });
    }
  